<template>
    <div id="charLib">
        <div class="main-panel">
            <div>
                <div class="main-panel__header">
                    <el-date-picker
                        size="medium"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        style="width: 240px;"
                        :clearable="false"
                        v-model="dateRange"
                        @change="getList"
                    ></el-date-picker>
                    <el-select size="medium" @change="getList()" v-model="type" placeholder="请选择"
                               style="width:120px">
                        <el-option label="全部类型" :value="'0'"></el-option>
                        <el-option :value="1" label="增加"></el-option>
                        <el-option :value="2" label="删除"></el-option>
                        <el-option :value="3" label="修改"></el-option>
                        <el-option :value="4" label="登录"></el-option>
                    </el-select>                    
                    <el-input style="width: 240px" class="search-input search-input--right"
                              size="medium"
                              placeholder="请输入查询信息"
                               icon="el-icon-search" @keyup.enter.native="handleInputChange"
                              v-model.trim="searchVal">
                        <el-button slot="append" size="medium" icon="el-icon-search"
                                   @click="getList"></el-button>
                    </el-input>
                </div>

            </div>
            <div>
                <el-table
                    :height="windowHeight - 210"
                    :data="dataList"
                    style="width: 100%" border
                >
                    <el-table-column
                        label="操作员"
                        prop="operationName"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作时间"
                        align="center" show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{scope.row.operationDate | timeSuffixFilter}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="被操作学校" show-overflow-tooltip
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.schoolName}}({{scope.row.schoolId}})
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作功能"
                        align="center" show-overflow-tooltip
                        prop="type"
                    >
                        <template slot-scope="scope">
                            {{scope.row.type | typeFilter}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="数据"
                        align="center" show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{scope.row.dataName}}({{scope.row.dataId}})
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作内容" show-overflow-tooltip
                        align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.dataContent" class="link" @click="showContent(scope.row)">{{scope.row.businessName}}</span>
                            <span v-else>{{scope.row.businessName}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination
                        @size-change="sizeChangeHandler"
                        @current-change="currentChangeHandler"
                        :current-page.sync="pagination.pageNo"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size.sync="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="pagination.pages"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            title="数据操作详情展示"
            :visible.sync="isShowDialog"
            :close-on-press-escape='false'
            width="600px"
            :lock-scroll="false"
            :close-on-click-modal='false'
            :modal-append-to-body='false'
        >
            <div>
                {{dataContent}}
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment';
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';

    import {
        logList
    } from '@/api/system';


    export default {
        name: 'logList',
        mixins: [windowResize, baseMixin],
        data() {
            return {
                type: '0',
                dataList: [],
                isShowDialog: false,
                dateRange: [new Date, new Date],
                searchVal: '',
                dataContent: ''
            }
        },
        mounted() {
            this.logListFunc();
        },
        filters: {
            typeFilter(value) {
                return ['', '增加', '删除', '修改', '登录', '关注', '登录第三方', '第三方接口调用', 'mysql应用'][value];
            }
        },
        methods: {
            showContent(item) {
                this.isShowDialog = true;
                this.dataContent = item.dataContent;
            },
            getList() {
                this.logListFunc();
            },
            logListFunc() {
                logList({
                    type: this.type,
                    beginDate: moment(this.dateRange[0]).format('YYYY-MM-DD'),
                    endDate: moment(this.dateRange[1]).format('YYYY-MM-DD'),
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    searchVal: this.searchVal,
                })
                    .then(data => {
                        console.log(data)
                        const pageData = data;
                        this.pagination.total = pageData.pagination.total;
                        this.dataList = pageData.dataList;
                    })
            },
            handleInputChange() {
                this.selectedwordList = [];
                this.selectedCharIdList = [];
                this.sensitiveWord = this.sensitiveWord.trim();
                this.logListFunc();
            },
            sizeChangeHandler() {
                this.pagination.pageNo = 1;
                this.logListFunc();
            },
            currentChangeHandler() {
                this.logListFunc();
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    #charLib {
        height: 100%;
    }

    .group-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }

    .main-panel {
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .group-item--title {
        width: 100px;
        height: 26px;
        margin-left: 20px;
        margin-top: 10px;
        display: block;
        color: #7B7B7B;
    }

    .group-item {
        height: 30px;
        text-align: left;
        line-height: 30px;
        display: block;
        padding: 0 30px;
        cursor: pointer;
        border-radius: 2px;
        position: relative;

        .fa {
            float: right;
            margin: 7px 0 0 10px;
            display: none;
        }

        &:hover {
            background-color: #ECECEC;

            .fa {
                display: block;
            }
        }

        &.group-item--active {
            background-color: #409EFF;
            color: #fff;

            .fa-edit {
                color: #fff;
            }
        }

        .fa-trash {
            color: #f08080;
        }

        .fa-edit {
            color: #409EFF;
        }
    }

    .char-list {
        padding-top: 12px;
    }

    .word-item {
        float: left;
        box-sizing: border-box;
        height: 80px;
        border: 2px solid #ddd;
        margin: 0 10px 10px 0;
        text-align: center;
        padding: 14px;
        font-size: 36px;
        cursor: pointer;
        position: relative;

        .fa-edit {
            position: absolute;
            font-size: 16px;
            right: 5px;
            top: 5px;
            color: #409EFF;
            display: none;
        }

        &:hover {
            .fa-edit {
                display: block;
            }
        }

        &.word-item--active {
            border: 2px solid #409EFF;
        }
    }

    .main-panel__header {
        padding-bottom: 10px;
        // border-bottom: 1px solid #e4e7ed;
    }

    .char-container {
        width: 70px;
        height: 70px;
        font-size: 52px;
        margin: 0 auto;
        text-align: center;
        line-height: 80px;
        margin-bottom: 5px;
    }

    .form-item-container {
        width: 500px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 10px;
    }

    .dialog-value {
        display: inline-block;
        vertical-align: middle;
        width: 280px;
        text-align: left;
    }

    .uploader-container {
        width: 140px;
    }

    .dialog-label {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        text-align: right;
        margin-right: 10px;
    }

    .add-line {
        color: #409EFF;
        cursor: pointer;
    }

    .form-item-container--voice {
        & > * {
            vertical-align: top;
        }

        .fa-close {
            color: #f08080;
            margin-left: 10px;
        }
    }
    .link {
        color: #20a0ff;
        cursor: pointer;
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }

    #charLib .form-item-container--line {
        .upload-file-item {
            width: 80px;
            height: 80px;
        }

        .upload-file-item img {
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/log/logList.vue